<main class="installment-page">
    <a *ngIf="!isDemo" [routerLink]="backUrl" class="back-link"><i class="bi bi-arrow-left"></i> Torna ai pagamenti</a>
    <p *ngIf="isDemo" class="demo-notice">Anteprima locale · contratto di test simulato · nessun addebito reale</p>

    <div *ngIf="loading" class="page-state" role="status">Caricamento rate…</div>
    <div *ngIf="!loading && error" class="page-state page-state-error" role="alert">
        <p>{{ error }}</p>
        <button type="button" class="btn btn-outline-secondary" (click)="loadDetails()">Riprova</button>
    </div>

    <ng-container *ngIf="!loading && details as payment">
        <header class="payment-heading">
            <div>
                <h1>Rate di {{ payment.athleteName }}</h1>
                <p>{{ payment.categoryName }}</p>
            </div>
            <span class="payment-progress">{{ paidInstallments() }} di {{ payment.installments.length }} rate pagate</span>
        </header>

        <section class="payment-summary" aria-label="Riepilogo pagamento">
            <div><span>Totale</span><strong>{{ payment.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong></div>
            <div><span>Pagato</span><strong>{{ payment.paidAmount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong></div>
            <div><span>Da pagare</span><strong>{{ (payment.amount - payment.paidAmount) | currency:'EUR':'symbol':'1.2-2':'it' }}</strong></div>
        </section>

        <p class="card-in-use" *ngIf="payment.card?.last4 || payment.card?.expiry">
            <i class="bi bi-credit-card"></i>
            Carta in uso per le rate<span *ngIf="payment.card?.last4"> •••• {{ payment.card?.last4 }}</span><span *ngIf="payment.card?.expiry"> · scadenza {{ payment.card?.expiry }}</span>
        </p>
        <p class="card-in-use card-replacement-pending" *ngIf="payment.cardReplacementInProgress">
            Pagamento con una nuova carta in corso sul POS: gli addebiti automatici di questo piano sono sospesi per 30 minuti.
        </p>

        <section class="installment-list" aria-label="Dettaglio delle rate">
            <article class="installment" *ngFor="let installment of payment.installments"
                     [class.installment-failed]="installment.status === 'failed' || installment.status === 'unknown'">
                <div class="installment-main">
                    <div class="installment-index">{{ installment.number }}</div>
                    <div class="installment-title">
                        <h2>Rata {{ installment.number }}</h2>
                        <p *ngIf="installment.status === 'failed'">Riprogrammata per il {{ installment.scheduledDate | date:'dd/MM/yyyy':'':'it' }}</p>
                        <p *ngIf="installment.status === 'pending' || installment.status === 'completed'">Prevista il {{ installment.scheduledDate | date:'dd/MM/yyyy':'':'it' }}</p>
                        <p *ngIf="installment.status === 'unknown'">Esito da verificare</p>
                        <p *ngIf="installment.status === 'processing'">Tentativo in corso</p>
                    </div>
                    <strong class="installment-amount">{{ installment.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong>
                    <span class="installment-status" [ngClass]="installment.status">{{ statusLabel(installment.status) }}</span>
                </div>

                <div class="installment-note" *ngIf="installment.status === 'completed' && installment.paidAt">
                    Pagata il {{ installment.paidAt | date:'dd/MM/yyyy HH:mm':'':'it' }}
                </div>
                <div class="installment-note error-note" *ngIf="installment.errorMessage">
                    <strong>Ultimo errore</strong><span>{{ installment.errorMessage }}</span>
                </div>
                <div class="installment-actions" *ngIf="installment.canReplaceCard && !isDemo">
                    <button type="button" class="btn btn-sm welldone-btn-light" (click)="replaceCard(installment)">
                        <i class="bi bi-credit-card"></i> Paga con un'altra carta
                    </button>
                    <span>L'atleta paga questa rata al POS con una nuova carta, che verrà usata per le rate successive.</span>
                </div>
                <div class="installment-note" *ngIf="installment.nextRetryAt && installment.status === 'failed'">
                    Prossimo tentativo automatico: <strong>{{ installment.nextRetryAt | date:'dd/MM/yyyy HH:mm':'':'it' }}</strong>
                </div>
                <div class="installment-note" *ngIf="installment.status === 'unknown' || installment.status === 'processing'">
                    Il prossimo tentativo è sospeso finché l’esito precedente non viene verificato.
                </div>

                <div class="attempts" *ngIf="installment.attempts.length">
                    <h3>Tentativi precedenti</h3>
                    <div class="attempt" *ngFor="let attempt of installment.attempts">
                        <time>{{ attempt.attemptedAt | date:'dd/MM/yyyy HH:mm':'':'it' }}<small *ngIf="attempt.historical"> (orario dai log)</small></time>
                        <span class="attempt-status" [ngClass]="attempt.status">{{ statusLabel(attempt.status) }}</span>
                        <span class="attempt-reason">{{ attempt.errorMessage || (attempt.status === 'completed' ? 'Addebito riuscito' : 'Nessun dettaglio disponibile') }}</span>
                    </div>
                </div>
                <div class="installment-note" *ngIf="!installment.attempts.length && installment.status === 'failed'">
                    Lo storico dei tentativi precedenti alla registrazione della cronologia non è disponibile in questa pagina.
                </div>
            </article>
        </section>
    </ng-container>
</main>
